import { render, staticRenderFns } from "./Bands.vue?vue&type=template&id=9542c170&"
import script from "./Bands.vue?vue&type=script&lang=js&"
export * from "./Bands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports